// @flow
import { resetState } from '../tables/actions';
import { resetState as resetOrdersState } from '../order/actions';
import { deactivateReceipt } from '../admin/receipts/actions';

export default {
  onVisit: [resetState(), resetOrdersState(), deactivateReceipt()]
};
